'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/millisecondsFromNow.js
// module id = 258
// module chunks = 1